import {
  CHECKOUT_DETAIL_ACTION,
  COMMON_CONTENT_ACTION,
  CHECKOUT_ACTION_LOADER,
  PLACE_ORDER_ACTION,
  PLACE_ORDER_ACTION_LOADER,
  VAT_VALIDATION_SUCCESS,  // Add this
  VAT_VALIDATION_ERROR
} from "../type";

const initialState = {
  data: null,
  loader: false, // Controls global loader (e.g., for fetching checkout details)
  common_data: null,
  error: null,
  order: null,  // Store the order details when an order is placed
  orderLoader: false, // A specific loader for the place order action
  placeOrderError: null, // Error related to placing the order
  vatValidation: null
};

const checkoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHECKOUT_ACTION_LOADER:
      return {
        ...state,
        loader: action.loader,
        // If loading starts, clear previous error
        error: action.loader ? null : state.error
      };

    case CHECKOUT_DETAIL_ACTION:
      return {
        ...state,
        data: action.data || null,
        error: action.error || null,
      };

    case COMMON_CONTENT_ACTION:
      return { ...state, common_data: action.data };

    case PLACE_ORDER_ACTION_LOADER:
      return {
        ...state,
        orderLoader: action.loader,
        // If placing order starts, clear previous order error
        placeOrderError: action.loader ? null : state.placeOrderError
      };

    case PLACE_ORDER_ACTION:
      return {
        ...state,
        order: action.order || null, // Store order details on success
        placeOrderError: action.error || null, // Store error message if any
        orderLoader: false, // Set loader to false after action completes
      };
    case VAT_VALIDATION_SUCCESS:
       // Debug
      return {
        ...state,
        vatValidation: {
          valid: action.payload.valid,
          message: action.payload.message,
          verification_code: action.payload.verification_code,
          vat_number: action.payload.vat_number
        }
      };

    case VAT_VALIDATION_ERROR:
       // Debug
      return {
        ...state,
        vatValidation: {
          valid: false,
          message: action.error,
          verification_code: null
        }
      };

    default:
      return state;
  }
};

export default checkoutReducer;
